module.exports = __webpack_public_path__ + "static/img/600x600-HOME-3.a06e60d0.jpg";